/**
 * OA 入口帳戶檢查（設計 docs/2026-09-02-oa-entry-account-check-design.md §5.1）的決策純函式。
 * 副作用（打 API、navigate、sessionStorage）留在 LineLoginProvider，這裡只做可測的判斷。
 */
import type { EntryCheckData } from "@screen/Onboarding/registerApi";

export interface OaEntryParams { supplierId: string; shopCode: string }

/** 只認「本次 URL」帶的 supplier —— sessionStorage 殘值不觸發（避免每次開 app 都被攔）。 */
export const parseOaEntryFromSearch = (search: string): OaEntryParams | null => {
  const params = new URLSearchParams(search);
  const supplierId = (params.get("supplier") ?? "").trim().slice(0, 64);
  if (!supplierId) return null;
  const shopCode = (params.get("shopCode") ?? "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 12);
  return { supplierId, shopCode };
};

export type EntryCheckAction =
  | { kind: "proceed"; preferredContextId: number | null }
  | { kind: "redirect"; to: string };

export const resolveEntryCheckAction = (
  data: EntryCheckData,
  entry: OaEntryParams,
): EntryCheckAction => {
  if (data.status === "has_account") {
    return { kind: "proceed", preferredContextId: data.context_id };
  }
  const q = new URLSearchParams();
  q.append("supplier", entry.supplierId);
  if (entry.shopCode) q.append("shopCode", entry.shopCode);
  // 2026-09-02 拍板：拿掉 mode=addAccount——onboarding 頁自己會用「已註冊＋本次入口帶 supplier」
  // 判定要不要走加帳戶流程（見 Onboarding/index.tsx 的 isAddAccountFlow），這裡只需帶 supplier/shopCode。
  return { kind: "redirect", to: `/onboarding/flyer?${q.toString()}` };
};

/** 一次性偏好身分（F3 的 IdentitySwitchMenu 讀完即清）。 */
export const OA_ENTRY_PREFERRED_CONTEXT_KEY = "oa_entry_preferred_context";
